import { render, staticRenderFns } from "./Success.vue?vue&type=template&id=2ea82a6c";
import script from "./Success.vue?vue&type=script&lang=js";
export * from "./Success.vue?vue&type=script&lang=js";
import style0 from "./Success.vue?vue&type=style&index=0&id=2ea82a6c&prod&lang=less";

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;